import React from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import config from '../../config';
import loadingImg from "../../assets/loading.gif"

const CashRegisterList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const companyId = useSelector((state) => state.user.companyId);
    const role = useSelector((state) => state.user.role);

    const [addAllowed, setAddAllowed] = useState(false)
    const [deleteAllowed, setDeleteAllowed] = useState(false)

    const [cashLedgerList, setCashLedgerList] = useState([])
    const [err, setErr] = useState("")
    const [baskets, setBaskets] = useState([])
    const [categories, setCategories] = useState([])
    
    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    
    const [inputs, setInputs] = useState({
        clientName: "",
        clientCode: "",
        categoryId: 0,
        basketId: 0,
        fromDate: null,
        toDate: null,
        companyId: 0,
    })
    const [subTotal, setSubTotal] = useState(0);

    const [currentDate, setCurrentDate] = useState('')

    const email = useSelector((state) => state.user.email);
    const navigate = useNavigate();
    useEffect(() => {
        if (email === null || email === "") {
            navigate("/")
        }
    })

    useEffect(() => {
        const today = new Date();
        const dateString = today.toISOString().substring(0, 10);
        setCurrentDate(dateString);
        setInputs(prev => ({ ...prev, fromDate: dateString, companyId: companyId }));
        getBaskets();
        getCategories();
        getScreenActionRights(role);
        setIsLoading(false);
        // Initial data fetch
        if (companyId) {
            fetchCashLedgerList(1, pageSize);
        }
    }, [role, companyId])

    const getScreenActionRights = async (roleId) => {
        try {
            const encodedScreenName = encodeURIComponent('Cash Register');
            const queryParams = {
                params: {
                    roleId: roleId,
                    screenName: encodedScreenName
                }
            };
            const res = await axios.get(config.BL_API_URL + `/ScreenActionRoleMapController/v1/getScreenActionRights?roleId=${queryParams.params.roleId}&screenName=${queryParams.params.screenName}`);
            if (res.data)
                if (res.data.includes('Add'))
                    setAddAllowed(true)

            if (res.data.includes('Delete'))
                setDeleteAllowed(true)
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }
    const getCategories = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL + "/CashLedger/v1/getCashTransactionCategories");

            if (res.data)
                setCategories(res.data)
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const getBaskets = async (e) => {
        try {
            const res = await axios.get(config.BL_API_URL + "/basket/v1/getBasketByCompanyId", { params: { companyId } });

            if (res.data)
                setBaskets(res.data)
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const handleClearSearch = async (e) => {
        setInputs({
            clientName: "",
            clientCode: "",
            categoryId: 0,
            basketId: 0,
            fromDate: "",
            toDate: "",
            companyId: 0,
        });
        setCashLedgerList([]);
        setTotalRecords(0);
        setTotalPages(0);
        setCurrentPage(1);
        setSubTotal(0);
        setIsLoading(false);
    }

    // Fetch cash ledger data with pagination
    const fetchCashLedgerList = async (page = 1, size = pageSize) => {
        try {
            setIsLoading(true);
            setErr("");
            const requestBody = {
                basketId: inputs.basketId || null,
                clientName: inputs.clientName || null,
                clientCode: inputs.clientCode || null,
                fromDate: inputs.fromDate || null,
                toDate: inputs.toDate || null,
                categoryId: inputs.categoryId || null,
                companyId: inputs.companyId || companyId
            };

            const response = await axios.post(
                `${config.BL_API_URL}/CashLedger/v1/searchCashLedger?page=${page - 1}&size=${size}&sortBy=date&sortDir=desc`,
                requestBody,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.content) {
                setCashLedgerList(response.data.content);
                setTotalRecords(response.data.totalElements);
                setTotalPages(response.data.totalPages);
                setCurrentPage(page);

                // Calculate subtotal
                const total = response.data.content.reduce((acc, transaction) => {
                    if (transaction.transactionType === 'Payin') {
                        return acc + transaction.amount;
                    } else if (transaction.transactionType === 'Payout') {
                        return acc - transaction.amount;
                    } else {
                        return acc;
                    }
                }, 0);
                setSubTotal(total.toFixed(2));
            } else {
                setCashLedgerList([]);
                setTotalRecords(0);
                setTotalPages(0);
                setSubTotal(0);
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching cash ledger data:", error);
            setErr("Error fetching cash ledger data. Please try again.");
            setCashLedgerList([]);
            setTotalRecords(0);
            setTotalPages(0);
            setSubTotal(0);
            setIsLoading(false);
        }
    };

    const handleSearch = async (e) => {
        fetchCashLedgerList(1, pageSize);
    };

    const deleteCashLedger = async (id) => {
        try {
            let ledgerId = Number(id);
            const res = await axios.get(config.BL_API_URL + "/CashLedger/v1/deleteById", { params: { ledgerId } });

            if (res.status === 200)
                fetchCashLedgerList(currentPage, pageSize);
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    function formatNumber(value) {
        return new Intl.NumberFormat('en-IN').format(value);
    }

    function formatDate(value) {
        if (value == null || value == undefined || value == "") {
            return;
        }
        return new Intl.DateTimeFormat('en-IN').format(value);
    }
    
    // Pagination helper functions
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchCashLedgerList(page, pageSize);
        }
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        fetchCashLedgerList(1, newSize);
    };

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };

    const renderPaginationButtons = () => {
        const buttons = [];
        const maxVisiblePages = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Previous button
        buttons.push(
            <button
                key="prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1 || isLoading}
                className="px-3 py-1 mx-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
            >
                Previous
            </button>
        );

        // Page number buttons
        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    disabled={isLoading}
                    className={`px-3 py-1 mx-1 text-sm border rounded ${
                        currentPage === i 
                            ? 'bg-blue-500 text-white border-blue-500' 
                            : 'hover:bg-gray-100'
                    }`}
                >
                    {i}
                </button>
            );
        }

        // Next button
        buttons.push(
            <button
                key="next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages || isLoading}
                className="px-3 py-1 mx-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
            >
                Next
            </button>
        );

        return buttons;
    };
    
    const handleChange = (e) => {
        setInputs(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    return (
        <div className="my-12 md:px-14 p-4 max-w-screen-2xl mx-auto ">
            {err && (
                <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
                    {err}
                </div>
            )}
            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">

                    <div className="border rounded-lg divide-y divide-gray-200 ">
                        <div className='col-span-10'>
                            <div className=" col-span-1">
                                <div className='col-span-10 px-2 py-2'>
                                    {/* Single Row Layout with Form Fields and Buttons */}
                                    <div className="flex gap-2 items-end overflow-x-auto">
                                        <div className="min-w-36 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>Basket Name</legend>
                                                <select
                                                    onChange={handleChange}
                                                    name="basketId" id="basketId"
                                                    className="w-full py-1 px-2 focus:outline-none text-xs"
                                                    value={inputs.basketId || ""}>
                                                    <option value="">-select-</option>
                                                    {baskets && (
                                                        baskets.map((basket, index) => <option key={index} value={basket.basketId}>{basket.name}</option>)
                                                    )}
                                                </select>
                                            </fieldset>
                                        </div>
                                        <div className="min-w-32 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>Client Name</legend>
                                                <input 
                                                    id="client-Name" 
                                                    name="clientName" 
                                                    onChange={handleChange} 
                                                    placeholder='Client name' 
                                                    className="w-full py-1 px-2 focus:outline-none text-xs" 
                                                    value={inputs.clientName || ""} 
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="min-w-28 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>Client Code</legend>
                                                <input 
                                                    id="client-Code" 
                                                    name="clientCode" 
                                                    onChange={handleChange} 
                                                    placeholder='Code' 
                                                    className="w-full py-1 px-2 focus:outline-none text-xs" 
                                                    value={inputs.clientCode || ""} 
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="min-w-28 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>Category</legend>
                                                <select
                                                    onChange={handleChange}
                                                    name="categoryId" id="categoryId"
                                                    className="w-full py-1 px-2 focus:outline-none text-xs"
                                                    value={inputs.categoryId || ""}>
                                                    <option value="">Select</option>
                                                    {categories && (
                                                        categories.map((category, index) => <option key={index} value={category.id}>{category.name}</option>)
                                                    )}
                                                </select>
                                            </fieldset>
                                        </div>
                                        <div className="min-w-32 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>From Date</legend>
                                                <input
                                                    onChange={handleChange}
                                                    type="date" 
                                                    name="fromDate" 
                                                    id="fromDate" 
                                                    className="w-full py-1 px-2 focus:outline-none text-xs" 
                                                    value={inputs.fromDate || ''}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="min-w-32 text-xs">
                                            <fieldset className='border-2 text-xs border-gray-200 p-1'>
                                                <legend className='mx-1 px-1'>To Date</legend>
                                                <input
                                                    onChange={handleChange}
                                                    type="date" 
                                                    name="toDate" 
                                                    id="toDate" 
                                                    className="w-full py-1 px-2 focus:outline-none text-xs" 
                                                    value={inputs.toDate || ''}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="min-w-20 text-xs">
                                            <button 
                                                type="button" 
                                                disabled={isLoading} 
                                                onClick={e => handleSearch()} 
                                                className="w-full py-2 px-2 inline-flex justify-center items-center gap-x-1 text-xs font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none whitespace-nowrap">
                                                {isLoading ? (
                                                    <img src={loadingImg} alt="Icon" className="w-3 h-3" />
                                                ) : (
                                                    'Search'
                                                )}
                                            </button>
                                        </div>
                                        <div className="min-w-16 text-xs">
                                            <button 
                                                type="button"  
                                                onClick={e => handleClearSearch()} 
                                                className="w-full py-2 px-2 text-xs font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary whitespace-nowrap">
                                                Clear
                                            </button>
                                        </div>
                                        <div className="min-w-36 text-xs">
                                            <Link 
                                                to={addAllowed ? "/addCashTransaction" : "#"} 
                                                className={`w-full py-2 px-2 inline-flex justify-center items-center text-xs font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary whitespace-nowrap ${!addAllowed ? 'disabled:opacity-80 disabled:pointer-events-none cursor-not-allowed' : 'cursor-allowed'}`}>
                                                Add Transaction
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Table Section with Pagination Controls */}
                        <div className="overflow-hidden">
                            {/* Pagination Controls - Top Right */}
                            {totalRecords > 0 && (
                                <div className="mb-2 flex justify-end items-center">
                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-2">
                                            <label className="text-sm font-medium text-gray-700">Show:</label>
                                            <select
                                                value={pageSize}
                                                onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
                                                disabled={isLoading}
                                                className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span className="text-sm text-gray-700">records per page</span>
                                        </div>
                                        <div className="text-sm text-gray-700">
                                            Total Records: {totalRecords}
                                        </div>
                                        <div className="text-sm text-gray-700">
                                            Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalRecords)} of {totalRecords} entries
                                        </div>
                                        <div className="flex items-center">
                                            {renderPaginationButtons()}
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            <div className="overflow-hidden">
                                <div className="relative overflow-x-auto">
                                    <div className="max-h-96 overflow-y-scroll scrollbar-gutter-stable">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-50 sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Basket Name</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Client Name</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Client Code</th>
                                            <th scope="col" className="px-6 py-3 text-xs text-right font-medium text-gray-500 bg-gray-200 uppercase">Amount</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Category</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Sub-Category</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Date</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Status</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cashLedgerList &&

                                            cashLedgerList.map((cashLedger, index) => (
                                                <tr key={index} className={`${index % 2 === 0 ? '' : 'bg-gray-100'} cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-200`}>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.basketName}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.clientName}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.clientCode}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right  text-gray-800 ">{formatNumber(cashLedger.amount)}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.category}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.transactionType}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{formatDateForDisplay(cashLedger.updatedOn)}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger.reconciled}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">
                                                        <span
                                                            onClick={e => {
                                                                if (!deleteAllowed) {
                                                                    e.preventDefault();
                                                                } else {
                                                                    deleteCashLedger(cashLedger.ledgerId);
                                                                }
                                                            }}
                                                            className={`cursor-pointer ${!deleteAllowed ? 'opacity-50 pointer-events-none' : ''} cursor-not-allowed`}
                                                        >
                                                            <Link to="#">
                                                                <FaTrash />
                                                            </Link>
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        {(cashLedgerList === null || cashLedgerList.length <= 0) &&
                                            <tr><td colSpan={9} className='text-center text-red-500 py-4'>No records to display!</td></tr>
                                        }
                                        {subTotal !== 0 && cashLedgerList.length > 0 &&
                                            <tr className="bg-blue-50 font-semibold">
                                                <td colSpan={3} className='text-center text-blue-600 py-2'>Page Total:</td>
                                                <td className='text-center text-blue-600 py-2'>{formatNumber(subTotal)}</td>
                                                <td colSpan={5} className='text-center text-blue-600 py-2'></td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CashRegisterList;